export const landingData = {
  clients: [
    {
      name: "PT Freeport Indonesia",
      logo: "images/landing/client/client 1.svg",
    },
    { name: "PGN", logo: "images/landing/client/client 2.svg" },
    { name: "Petrochina", logo: "images/landing/client/client 3.svg" },
    { name: "SRB", logo: "images/landing/client/client 4.svg" },
    { name: "Twin", logo: "images/landing/client/client 5.svg" },
    { name: "Blue Coral", logo: "images/landing/client/client 6.svg" },
    { name: "DAB Nusantara", logo: "images/landing/client/client 7.svg" },
  ],
  services: [
    {
      id: 1,
      title:
        "Thermal Insulation Coating, Thermal Insulation Calculation Details, Thermal Analysis",
      description:
        "Kami menawarkan jasa pelapisan isolasi termal yang dirancang untuk mengurangi kehilangan panas dan meningkatkan efisiensi energi pada berbagai jenis infrastruktur. Layanan kami mencakup perhitungan isolasi termal untuk memastikan ketebalan yang optimal serta desain dan analisis termal untuk memastikan performa terbaik dari sistem isolasi yang digunakan.",
      image: "images/landing/img-1.png",
    },
    {
      id: 2,
      title: "Corrosion Under Insulation Service",
      description:
        "Kami menyediakan layanan untuk mengatasi korosi yang terjadi di bawah lapisan isolasi. Salah satu solusi kami adalah instalasi rectifier transformer yang membantu menjaga stabilitas pipa dan memastikan arus bawah tanah tetap pada tegangan yang stabil.",
      image: "images/landing/img-2.png",
    },
    {
      id: 3,
      title:
        "Services Impressed Current Cathodic Protection (ICCP) & Sacrificial Anode Cathodic Protection (SACP)",
      description:
        "Kami menyediakan layanan perlindungan katodik menggunakan dua metode utama: ICCP dan SACP. Kedua metode ini dirancang untuk mencegah korosi dan memperpanjang masa pakai infrastruktur logam, seperti pipa dan tangki.",
      image: "images/landing/img-3.png",
    },
  ],
};
